import React from 'react';
import PropTypes from 'prop-types';

const SectionHeading = ({ title, subtitle, viewMoreLink }) => (
  <div className="section-heading border-bottom-1 border-color-grey--light p-b-3 m-b-3 d-flex justify-content-space-between">
    <div>
      <h2 className="like-h3 m-b-0">{title}</h2>
      {subtitle &&
        <p className="like-h5 text-grey m-b-0">{subtitle}</p>
      }
    </div>
    {viewMoreLink && <a href={viewMoreLink} className="hidden-sm-down like-h5 m-b-0 fw-medium align-self-end m-l-5">View all</a> }
  </div>
);

SectionHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  viewMoreLink: PropTypes.string,
};

export default SectionHeading;



// WEBPACK FOOTER //
// ./library/app/components/Global/Typography/SectionHeading.js